import React, { Component } from "react";
import { Table, Image, Checkbox } from "semantic-ui-react";
import { connect } from "react-redux";
import { parseString } from "xml2js";
import _ from "lodash";
import { expireSession } from "../../actions/auth";
import api from "../../api";
import settings from "../../settings";
import CaseButtons, { getActivitiesEditButtons } from "./CaseEditButtons";
import EditCaseDetails from "./EditCaseDetails";
import Check from "../../assets/images/check.gif";
import Cross from "../../assets/images/xred.gif";
import { getErrorMessage } from "../messages/errorMessages";
import { encodeUrl } from "../../utils/urlHelper";
import {getErrorNode} from "../../utils/errorUtil";

class CaseActivities extends Component {
  state = {
    rows: [],
    selectedActivities: [],
    view: undefined,
    confirmDelete: false,
    errorNode: undefined
  };

  componentDidMount() {
    this.loadActivities(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadActivities(nextProps);
  }

  componentWillUnmount() {
    this.isCompMounted = false;
  }

  onChange = (e, data) => {
    const selectedActivities = this.state.selectedActivities;
    selectedActivities[parseInt(data.id, 10)] = data.checked;
    this.setState({ selectedActivities });
  };

  getActivityDescription = (activity, report) => {
    const activityDescription = activity.actDesc[0];
    const displayActivityDescription = activity.actDesc[0].indexOf("searchID")
      ? activityDescription.split("_")[0]
      : activityDescription;
    if (report) {
      const { uiData } = this.props;
      const leftMenuItem = _.find(
        uiData.Menus.MenuItems,
        (m) => m.ReportId === parseInt(report.ReportID[0], 10)
      );

      if (leftMenuItem) {
        return (
          <span
            role="button"
            tabIndex={0}
            className={"url-link-activity"}
            onClick={() => this.redirectToLink(activity.actId[0], report)}
          >
            {displayActivityDescription}
          </span>
        );
      }
    }

    return displayActivityDescription;
  };

  redirectToLink = (actId, report) => {
    const { uiData } = this.props;
    const leftMenuItem = _.find(
      uiData.Menus.MenuItems,
      (m) => m.ReportId === parseInt(report.ReportID[0], 10)
    );
    if (leftMenuItem) {
      const subMenuItem = _.find(
        uiData.Menus.MenuItems,
        (m) => m.MenuId === leftMenuItem.ParentId
      );
      const mainMenuItem = _.find(
        uiData.Menus.MenuItems,
        (m) => m.MenuId === subMenuItem.ParentId
      );
      api.lp
        .getActivityFieldValues({
          activityId: parseInt(actId, 10),
          userCode:
            this.props.pickuser && this.props.pickuser !== ""
              ? this.props.pickuser
              : this.props.user.userID,
          appname: settings.appName,
          token: localStorage.getItem("sessionID"),
        })
        .then((res) => {
          if (
            this.isCompMounted &&
            res.data.Status === "OK" &&
            res.data.Data &&
            res.data.Data.length > 0
          ) {
            const searchFormField = _.find(
              res.data.Data,
              (p) => p.FieldId === 0
            );

            if (searchFormField) {
              const selectedForm = [];
              const formControls = _.filter(
                uiData.FormData,
                (a) => a.FormId === parseInt(searchFormField.FieldValue, 10)
              );
              _.forEach(res.data.Data, (fv) => {
                if (fv.FieldId !== 0) {
                  const control = _.find(
                    formControls,
                    (fc) => fc.FieldId === fv.FieldId
                  );
                  if (control) {
                    if (control.FieldName === "dob") {
                      const dobTokens = fv.FieldValue.split("/");
                      if (dobTokens.length > 2) {
                        selectedForm.dobYear = parseInt(dobTokens[2], 10);
                      }
                      if (dobTokens.length > 1) {
                        selectedForm.dobDay = parseInt(dobTokens[1], 10);
                      }
                      selectedForm.dobMonth = parseInt(dobTokens[0], 10);
                      selectedForm[control.FieldName] = dobTokens.join("%252F");
                    } else {
                      selectedForm[control.FieldName] = fv.FieldValue;
                    }
                  }
                } else {
                  localStorage.previewMenuItem = this.customArryToJson({
                    FormID: fv.FieldValue,
                  });
                }
              });
              localStorage.searchPreviewData = this.customArryToJson(
                selectedForm
              );
              localStorage.selectedFolderCode = this.props.currentCase.folderCode;
              this.props.history.push(
                `/search/${encodeUrl(mainMenuItem.MenuTitle)}/${encodeUrl(
                  subMenuItem.MenuTitle
                )}/${encodeUrl(leftMenuItem.MenuTitle)}/${leftMenuItem.MenuId}`
              );
            }
          }
        })
        .catch((err) => console.log("load case charges error - ", err));
    }
  };

  customArryToJson = (data) => {
    let str = "";
    _.forEach(Object.keys(data), (key) => {
      str = `${str}${str.length > 0 ? "," : ""}"${key}":"${data[key]}"`;
    });
    return `{${str}}`;
  };

  isCompMounted = false;

  loadActivities = (props) => {
    this.isCompMounted = true;
    props.onLoadStart();
    const params = {
      view: props.caseView,
      sserver: settings.appName,
      userID: props.user.userid,
      pickedUser: props.pickuser,
      currentFolder: props.currentCase.folderCode,
      sessionID: localStorage.getItem("sessionID"),
    };
    api.lp
      .getActivitiesView(params)
      .then((res) => {
          parseString(res.data, { async: false }, (err, result) => {
            if(result == null) {
                const errorNode = getErrorNode();
                this.setState({ errorNode });
                return;
            }	
          const root = Object.keys(result)[0];
          if (root === "errors") {
            if (
              _.get(result, `${root}.error[0].$.errType`) === "unauthorized"
            ) {
              localStorage.errorMessage = _.get(
                result,
                `${root}.error[0].errMsg[0]`,
                ""
              );
              const errorMessage = getErrorMessage(
                localStorage.errorMessage,
                _.get(result, `${root}.error[0].errMsg[0]`, "")
              );
              this.props.expireSession(errorMessage);
            }
          } else {
            const activities = _.get(result, "activities.activity");
            const rows = [];
            const selectedActivities = [];
            const reports = _.get(
              result,
              "activities.searchMenu[0].soap:Envelope[0].soap:Body[0].GetUserSearchListExResponse[0].GetUserSearchListExResult[0].UserItems[0].Reports[0].row"
            );
            _.forEach(activities, (activity, index) => {
              let reportId = activity.actReportID[0];
              if (reportId === "8") reportId = "6";
              else if (
                reportId === "10" ||
                reportId === "11" ||
                reportId === "12"
              )
                reportId = "9";
              else if (reportId === "16") reportId = "15";
              const report = _.find(reports, (a) => a.ReportID[0] === reportId);
              const actId = _.get(activity, "actId[0]");
              const actChecked = _.get(activity, "inOut[0]") === "in";
              selectedActivities[actId] = actChecked;
              if (this.isCompMounted) {
                this.setState({ selectedActivities });
              }
              rows.push(
                <Table.Row
                  key={`act_view_row_${index}`}
                  className={index % 2 === 0 ? "table-row-odd-child" : ""}
                >
                  {this.props.caseView === "folderedit" && (
                    <Table.Cell>
                      <Checkbox
                        id={actId}
                        name={`name_${actId}`}
                        defaultChecked={this.state.selectedActivities[actId]}
                        onChange={this.onChange}
                      />
                    </Table.Cell>
                  )}
                  <Table.Cell>
                    {parseInt(_.get(activity, "actCode[0]", "0"), 10) > 0 ? (
                      <Image
                        inline
                        src={Check}
                        className={"icon-align-middle"}
                      />
                    ) : (
                      <Image
                        inline
                        src={Cross}
                        className={"icon-align-middle"}
                      />
                    )}
                    {report &&
                      (_.get(report, "ReportCategory[0]") === "Report"
                        ? _.get(report, "ReportLabel[0]", "")
                        : `${_.get(
                            report,
                            "ReportTypeDescription[0]",
                            ""
                          )}: ${_.get(report, "ReportLabel[0]", "")}`)}
                  </Table.Cell>
                  <Table.Cell>
                    {this.getActivityDescription(activity, report)}
                  </Table.Cell>
                  <Table.Cell>{_.get(activity, "actCost[0]", "")}</Table.Cell>
                  <Table.Cell>
                    {`${_.get(activity, "actCode[0]", "0")} recs`}
                  </Table.Cell>
                  <Table.Cell>
                    {_.get(activity, "actUpdateFormatted[0]", "")}
                  </Table.Cell>
                </Table.Row>
              );
            });

            const total = _.get(result, "activities.t[0].total[0]");
            if (this.isCompMounted) {
              this.setState({
                rows,
                total,
                selectedActivities,
                view: this.props.caseView,
              });
            }
          }
          props.onLoadComplete();
        });
      })
      .catch((err) => console.log("load case view activities error - ", err));
  };

  updateCase = () => {
    this.props.viewCaseActivitiesPane();
  };

  cancelEdit = () => {
    this.props.viewCaseActivitiesPane();
  };

  saveActivities = () => {
    const checkedActs = [];
    _.forEach(Object.keys(this.state.selectedActivities), (key) => {
      if (this.state.selectedActivities[key] === true) {
        checkedActs.push(parseInt(key, 10));
      }
    });

    this.updateCaseContents(checkedActs);
  };

  updateCaseContents = (checkedActs) => {
    this.props.onLoadStart();
    const params = {
      sserver: settings.appName,
      userCode:
        this.props.pickuser && this.props.pickuser !== ""
          ? this.props.pickuser
          : this.props.user.userID,
      folderCode: this.props.currentCase.folderCode,
      contents: checkedActs,
      sessionID: localStorage.getItem("sessionID"),
    };
    api.lp
      .updateCaseContents(params)
      .then((res) => {
        if (res !== undefined && res.errors !== undefined) {
          if (_.get(res, "errors.error.errType") === "unauthorized") {
            this.props.expireSession();
          }
        } else {
          this.props.viewCaseActivitiesPane();
        }
        this.props.onLoadComplete();
      })
      .catch((err) => console.log("load case view activities error - ", err));
  };

  clearActivitiesSelection = () => {
    const selectedActivities = this.state.selectedActivities;
    _.forEach(Object.keys(selectedActivities), (key) => {
      selectedActivities[key] = false;
    });
    this.setState({ selectedActivities });
    this.updateCaseContents([]);
  };

  cancelActivitiesSelection = () => {
    this.props.viewCaseActivitiesPane();
  };

  showConfirm = () => {
    this.setState({ confirmDelete: true });
  };

  closeConfirm = () => {
    this.setState({ confirmDelete: false });
  };

  render() {
    const {errorNode} = this.state;
    if(errorNode !== undefined) return errorNode;
    let buttons = <CaseButtons {...this.props} />;
    if (this.props.caseView === "folderedit")
      buttons = getActivitiesEditButtons({
        saveActivities: this.saveActivities,
        clearActivitiesSelection: this.clearActivitiesSelection,
        cancelActivitiesSelection: this.cancelActivitiesSelection,
      });
    return (
      <div>
        {buttons}
        {this.props.caseView === "editCasePricing" ? (
          <EditCaseDetails
            {...this.props}
            updateCase={this.updateCase}
            cancelEdit={this.cancelEdit}
            buttonText={"Save"}
          />
        ) : (
          <Table>
            <Table.Body>
              <Table.Row className="report-section-header">
                {this.state.view === "folderedit" && (
                  <Table.HeaderCell width={1}>ADD</Table.HeaderCell>
                )}
                <Table.HeaderCell width={3}>Activity</Table.HeaderCell>
                <Table.HeaderCell width={5}>Description</Table.HeaderCell>
                <Table.HeaderCell width={2}>Cost</Table.HeaderCell>
                <Table.HeaderCell width={2}>Found</Table.HeaderCell>
                <Table.HeaderCell width={3}>Date</Table.HeaderCell>
              </Table.Row>
              {this.state.rows}
              {this.state.total && (
                <Table.Row className="control-sub-title">
                  <Table.Cell colSpan={2}>
                    <div className={"float-right"}>Total</div>
                  </Table.Cell>
                  <Table.Cell colSpan={3}>{this.state.total}</Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    uiData: state.uiData,
  };
}

export default connect(mapStateToProps, { expireSession })(CaseActivities);



// WEBPACK FOOTER //
// ./src/components/myaccount/CaseActivities.js